import React, { Component } from 'react';
import MaterialTable from 'material-table';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import Button from "@material-ui/core/Button";
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import {
    typeOfIPAOptions,
    typeOfFAYearOptions,
    typeOfFAMAOptions,
    sectorOptions,
    typeOfAnnualOptions,
    typeOfProjectOptions,
    returnTypeIdNameArrayElement
} from '../components/Enums';

export class ProjectTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //projectList: [{ name: 'Proje 1', id: 1 }, { name: 'Proje 2', id: 2 }],
            projectList: [],
            isActive: true,
            userType: -1,
            isLoadingFinished: false,
        };
    }

    getListofAllProjects() {
        let pageData = { operation: "GetListOfAllProjects" };

        fetch(global.variables.API_PROJECTDETAILS_GETLISTOFALLPROJECTS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {

                    let p = result.projects;
                    for (var i = 0; i < p.length; ++i) {
                        p[i].SectorName = returnTypeIdNameArrayElement(sectorOptions, p[i].Sector).TypeName;
                    }

                    //this.setState({ projectList: result.projects });
                    this.setState({ projectList: p });
                } else {
                    this.setState({ projectList: null });
                }
            });
    }

    getListofActiveProjects() {
        let pageData = { operation: "GetListOfActiveProjects" };

        fetch(global.variables.API_PROJECTDETAILS_GETLISTOFACTIVEMISSIONEDPROJECTS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {

                    let p = result.projects;
                    for (var i = 0; i < p.length; ++i) {
                        //console.log(p[i].Sector);
                        //console.log(returnTypeIdNameArrayElement(sectorOptions, p[i].Sector));
                        //console.log(returnTypeIdNameArrayElement(sectorOptions, p[i].Sector).TypeName);

                        p[i].SectorName = returnTypeIdNameArrayElement(sectorOptions, p[i].Sector).TypeName;

                        //console.log(p[i].SectorName);
                        //console.log("----");
                    }

                    //this.setState({ projectList: result.projects });
                    this.setState({ projectList: p });
                } else {
                    this.setState({ projectList: null });
                }
            });
    }

    handleActiveToggle = () => {
        if (this.state.isActive) {
            this.getListofAllProjects();
        } else {
            this.getListofActiveProjects();
        }

        this.setState({
            isActive: !this.state.isActive
        });
    };

    componentDidMount = async () => {

        //var postFormData = new FormData();
        //postFormData.append("operation", "AuthCheckToken");

        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        await this.getUserType();
        await this.getListofActiveProjects();

        //if (this.state.userType === 2 || this.state.userType === 4) {
        //    await this.getListofAllProjects();
        //} else {
        //    await this.getListofActiveProjects();
        //}

        await this.setState({ isLoadingFinished: true });
    };

    getUserType = () => {
        let pageData = {
            operation: "GetUserType"
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userType: result.userType });
            });
    }

    render() {
        const {
            isActive,
            userType,
            isLoadingFinished,
        } = this.state;

        if (userType === -1) {
            //return (
            //    <div />
            //);
            return (
                <CircularProgress />
            );
        } else if (userType === 1) {
            return (
                <Grid xs={12}>
                    <p style={{
                        fontSize: '2.125rem',
                        fontFfamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        fontWeight: '400',
                        lineHeight: '1.17',
                        letterSpacing: '0.00735em'
                    }}>ROMIS Administrator Panel</p>
                </Grid>
            );
        } else {

            if (!isLoadingFinished) {

                return (
                    <CircularProgress />
                );

            } else {

                return (
                    <div style={{ maxWidth: '100%' }}>

                        <Grid xs={12}>
                            <p style={{
                                fontSize: '2.125rem',
                                fontFfamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                fontWeight: '400',
                                lineHeight: '1.17',
                                letterSpacing: '0.00735em'
                            }}>Project List</p>
                        </Grid>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleActiveToggle.bind(this)}
                            fullWidth
                            style={{ marginBottom: "15px", display: userType === 2 || userType === 4 ? "block" : "none" }}
                        >
                            {isActive ? "Show All Projects" : "Show Only Active ROM Projects"}
                        </Button>

                        <MaterialTable
                            columns={[
                                { title: 'Project Id', field: 'idProjectDetails', hidden: true },
                                { title: 'Project Number', field: 'ProjectNumber' },
                                { title: 'Project Name', field: 'ProjectTitle' },
                                { title: 'Project Sector', field: 'SectorName' },
                            ]}
                            data={this.state.projectList}
                            title={isActive ? "Active Projects" : "All Projects"}
                            actions={[
                                {
                                    icon: 'info',
                                    tooltip: 'Project Details',
                                    onClick: (event, rowData) => {
                                        this.props.history.push(`/projectdetails/${rowData.idProjectDetails}`);
                                    },
                                },
                                //{
                                //    icon: 'info',
                                //    tooltip: 'Project Monitoring',
                                //    onClick: (event, rowData) => {
                                //        this.props.history.push(`/cycleofthereport/${rowData.idProjectDetails}`);
                                //    },
                                //},
                                {
                                    icon: 'input',
                                    tooltip: 'Mission List',
                                    onClick: (event, rowData) => {
                                        this.props.history.push(`/missionlist/${rowData.idProjectDetails}`);
                                    },
                                },
                            ]}
                            options={{
                                actionsColumnIndex: -1,
                                //rowsPerPageOptions: [20, 10, 5],
                                //rowsPerPage: 20,
                                pageSize: 20
                            }}
                        />
                    </div>
                );
            }
        }
    }
}








// WEBPACK FOOTER //
// ./src/pages/ProjectTable.js